// src/api/public.js
import axios from "axios";
import { API_BASE_URL } from "../config";

// Get public platform statistics (no auth required)
export async function getPublicStats() {
  try {
    const response = await axios.get(`${API_BASE_URL}/public/stats`);
    return response.data;
  } catch (error) {
    console.error("Error fetching public stats:", error);
    // Return default values if API fails
    return {
      total_users: 0,
      partners_count: 0,
      agencies_count: 0,
      total_trips: 0,
      active_trips: 0,
      completed_trips: 0,
      top_destinations: [],
      total_connections: 0,
      total_ratings: 0,
      average_rating: 0,
      total_notifications: 0,
      gender_distribution: {
        male: 0,
        female: 0,
        other: 0
      }
    };
  }
}
